<template><div><p class="d-docsite--paragraph">The hovercard will appear upon the mouse entering the anchor, with a delay of 300 milliseconds. It will remain open as long as the mouse cursor is over either the open card or the anchor.</p>
<code-well-header>
  <example-hovercard />
</code-well-header>
<code-example-tabs
htmlCode='
<div data-qa="dt-hovercard">
  <div class="d-popover d-popover__anchor--opened" data-qa="dt-popover-container">
    <div id="DtPopover__anchor21" data-qa="dt-hovercard-anchor">
      <button class="base-button__button d-btn d-btn--outlined d-btn--muted" data-qa="dt-button" type="button" aria-expanded="true">
        <span data-qa="dt-button-label" class="d-btn__label base-button__label">
          Hover over me
        </span>
      </button>
    </div>
  </div>
</div>
<div class="tippy-box d-ps-absolute" data-tippy-root="" id="tippy-11" style="z-index: 300; position: absolute; inset: 0px auto auto 0px; margin: 0px; transform: translate3d(874px, 365px, 0px);" data-popper-placement="bottom-start">
  <div id="dt20" role="dialog" data-qa="dt-hovercard__dialog" aria-hidden="false" aria-labelledby="DtPopover__anchor21" aria-modal="true" class="d-popover__dialog" tabindex="-1" style="">
    <div data-qa="dt-popover-header-footer" class="d-popover__header d-pl16">
      <div data-qa="dt-popover-header-footer-content" class="d-popover__header__content">
        <div>Header</div>
      </div>
    </div>
    <div data-qa="dt-hovercard-content" class="d-popover__content d-p16">
      <div>Content</div>
    </div>
    <div data-qa="dt-popover-header-footer" class="d-popover__footer d-pl16">
      <div data-qa="dt-popover-header-footer-content" class="d-popover__footer__content">
        <div>Footer</div>
      </div>
    </div>
  </div>
</div>
'
vueCode='
<dt-hovercard placement="bottom-start">
  <template #anchor>
    <dt-button kind="muted" importance="outlined">
      Hover over me
    </dt-button>
  </template>
  <template #content>
    <div>Content</div>
  </template>
  <template #headerContent>
    <div>Header</div>
  </template>
  <template #footerContent>
    <div>Footer</div>
  </template>
</dt-hovercard>
'
showHtmlWarning />
<h2 id="variants" tabindex="-1" class="d-docsite--header-2">Variants <a class="header-anchor d-link d-docsite--link d-link" href="#variants" aria-hidden="true">#</a></h2>
<h3 id="many-hovercards" tabindex="-1" class="d-docsite--header-3">Many Hovercards <a class="header-anchor d-link d-docsite--link d-link" href="#many-hovercards" aria-hidden="true">#</a></h3>
<code-well-header>
  <dt-stack direction="row" gap="500">
    <example-hovercard v-for="data in exampleData" :label="data.label" :content="data.content" />
  </dt-stack>
</code-well-header>
<h2 id="vue-api" tabindex="-1" class="d-docsite--header-2">Vue API <a class="header-anchor d-link d-docsite--link d-link" href="#vue-api" aria-hidden="true">#</a></h2>
<component-vue-api component-name="hovercard" /></div></template>


<script setup>
  import ExampleHovercard from '@exampleComponents/ExampleHovercard.vue';

  const exampleData = [
    {
      label: 'Example 1',
      content: 'Content 1',
    },
    {
      label: 'Example 2',
      content: 'Content 2',
    },
    {
      label: 'Example 3',
      content: 'Content 3',
    },
  ];
</script>